import { render } from "./Main.vue?vue&type=template&id=908dd9b2"
const script = {}
script.render = render

export default script